import React from 'react';
import {
  Box,
  Paper,
  Grid,
  TextField,
  IconButton,
  Button,
  Typography,
  Divider,
} from '@material-ui/core';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import DeleteIcon from '@material-ui/icons/Delete';
import { map } from 'lodash';

const PayingMemberBenefitsEditor = (props) => {
  const { benefits = [], onChange, disabled = false } = props;

  const handleAdd = () => {
    const newBenefits = [...benefits, ''];
    onChange(newBenefits);
  };

  const handleChange = (index, value) => {
    const newBenefits = [...benefits];
    newBenefits[index] = value;
    onChange(newBenefits);
  };

  const handleDelete = (index) => {
    const newBenefits = benefits.filter((_, i) => i !== index);
    onChange(newBenefits);
  };

  return (
    <Box>
      <Grid
        container
        direction="row"
        justify="space-between"
        alignItems="center">
        <Grid item>
          <Typography variant="h6" gutterBottom>
            VIP會員共享福利
          </Typography>
        </Grid>
        <Grid item>
          <Button
            variant="contained"
            color="primary"
            size="small"
            startIcon={<AddCircleOutlineIcon />}
            onClick={handleAdd}
            disabled={disabled}>
            新增福利
          </Button>
        </Grid>
      </Grid>

      <Divider style={{ marginTop: '8px', marginBottom: '16px' }} />

      {benefits.length === 0 && (
        <Box p={2} textAlign="center">
          <Typography variant="body2" color="textSecondary">
            目前沒有福利項目，請點擊「新增福利」按鈕新增
          </Typography>
        </Box>
      )}

      {map(benefits, (benefit, index) => (
        <Box
          key={index}
          component={Paper}
          variant="outlined"
          p={2}
          mb={2}
          style={{ position: 'relative' }}>
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={11}>
              <TextField
                fullWidth
                label={`福利項目 ${index + 1}`}
                placeholder="例如：共享空間可享第二小時優惠價"
                value={benefit || ''}
                onChange={(e) => handleChange(index, e.target.value)}
                disabled={disabled}
              />
            </Grid>
            <Grid item xs={1} style={{ textAlign: 'right' }}>
              <IconButton
                color="secondary"
                onClick={() => handleDelete(index)}
                disabled={disabled}
                size="small">
                <DeleteIcon />
              </IconButton>
            </Grid>
          </Grid>
        </Box>
      ))}
    </Box>
  );
};

export default PayingMemberBenefitsEditor;
